import { jsx, jsxs } from 'react/jsx-runtime';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmInfoCircle } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';

const Disclaimer = props => {
  const label = useLabel();
  const app = useLlm(state => state.app);
  const appDisclaimer = app === null || app === void 0 ? void 0 : app.contents.disclaimer;
  const disclaimer = appDisclaimer || label('llm.disclaimer');
  return disclaimer && jsx("div", {
    className: "llm__row",
    children: jsx("div", {
      className: "llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6",
      children: jsxs("small", {
        className: "llm__disclaimer",
        children: [jsx("i", {
          children: jsx(IconLlmInfoCircle, {})
        }), jsx("div", {
          dangerouslySetInnerHTML: {
            __html: disclaimer
          }
        })]
      })
    })
  });
};

export { Disclaimer };
//# sourceMappingURL=disclaimer.js.map
